import React from 'react';
import PropTypes from 'prop-types';
import Pagination from "components/Pagination/Pagination.jsx";
import { isEqual } from "lodash";

class CustomPagination extends React.Component {
  state = {
    pager: {},
  };

  componentWillMount() {
    this.setPage(this.props.initialPage, true);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.totalItens, this.props.totalItens)) {
      this.setPage(this.props.initialPage, true);
    }
  }

  setPage(page, initialization = false) {
    const { pageSize, totalItens } = this.props;
    let pager = this.state.pager;

    if (page < 1 || page > pager.totalPages) {
        return;
    }

    pager = this.getPager(totalItens, page, pageSize);
    this.setState({ pager });

    // call change page function in parent component
    if (!initialization) {
      this.props.onChangePage(page);
    }
  }

  getPager(totalItens, currentPage = 1, pageSize = 10) {
    const totalPages = Math.ceil(totalItens / pageSize);

    let startPage, endPage;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalItens - 1);

    // create an array of pages to repeat in the pager control
    const pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

    return {
      currentPage,
      endIndex,
      endPage,
      pageSize,
      pages,
      startIndex,
      startPage,
      totalItens,
      totalPages,
    };
  }

  render() {
    const { pager } = this.state;

    if (!pager.pages || pager.pages.length <= 1) {
      return null;
    }

    return (
      <div>
        <Pagination
          color="info"
          pages={[
            { disabled: pager.currentPage === 1, onClick: () => this.setPage(1), text: "Primeira" },
            { disabled: pager.currentPage === 1, onClick: () => this.setPage(pager.currentPage - 1), text: "Anterior" },
            ...pager.pages.map((page, index) => (
              { active: pager.currentPage === page, onClick: () => this.setPage(page), text: page }
            )),
            { disabled: pager.currentPage === pager.totalPages, onClick: () => this.setPage(pager.currentPage + 1), text: "Próxima" },
            { disabled: pager.currentPage === pager.totalPages, onClick: () => this.setPage(pager.totalPages), text: "Última" },
          ]}
        />
      </div>
    );
  }
}

CustomPagination.defaultProps = {
  initialPage: 1,
  pageSize: 20,
};

CustomPagination.propTypes = {
  initialPage: PropTypes.number,
  items: PropTypes.array.isRequired,
  onChangePage: PropTypes.func.isRequired,
  pageSize: PropTypes.number,
  totalItens: PropTypes.number,
};

export default CustomPagination;



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Pagination/custom-pagination.js